import { useQuery } from 'react-query';
import { getUserDetails } from '../sp-firebase/userFB';
import { SpotLockUser } from '../sp-types/userType';
import axios from 'axios';
const {
  VITE_FUNCTIONS_URL,
  //@ts-expect-error evn is not found
} = import.meta.env;

const fetchUser = async (uid: string | null): Promise<SpotLockUser | undefined> => {
  try {
    if (uid) {
      const userDetails = await getUserDetails(uid);
      if (userDetails) {
        // If no country filed in user - it sets it as IL
        userDetails.country = userDetails?.country || 'IL';
      }
      return userDetails || undefined;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

export const useUser = () => {
  const uid = sessionStorage.getItem('uid');
  return useQuery(['user', uid], () => fetchUser(uid), {
    enabled: !!uid, // Only fetch when UID exists
  });
};

export const sendEmail = async (uid: string, email: string, server: string = ''): Promise<string> => {
  const url = (server || VITE_FUNCTIONS_URL) + 'sendEmail';
  const response = await axios.post<string>(url, { uid, email });
  return response.data;
};
